import { cloneElement, isValidElement } from "react"
import AboutCompany from "./About/AboutCompany"
import MissionVision from "./About/MissionVision"
import ContactForm from "./Contact/ContactForm"
import SimpleContent from "./Content/SimpleContent"
import AsymmetricInfiniteScrollGridView from "./Content/AsymmetricInfiniteScrollGridView"
import ModernFAQ from "./Content/ModernFAQ"
import FeatureFlow from "./Features/FeatureFlow"
import SequentialFeaturesFlow from "./Features/SequentialFeaturesFlow"
import WhyChooseUs from "./Features/WhyChooseUs"
import HeroSectionWithBottomLabel from "./Hero/HeroSectionWithBottomLabel"
import HeroSectionWithScrollTrigger from "./Hero/HeroSectionWithScrollTrigger"
import ServiceHero from "./Hero/ServiceHero"
import MegaMenuNavbar from "./Navbar/MegaMenuNavbar"
import ModernNavbar from "./Navbar/ModernNavbar"
import SectionsDivider from "./SectionsDivider"
import ClientTestimonials from "./Testimonials/ClientTestimonials"
import ComprehensiveFooter from "./Footer/ComprehensiveFooter"

const specToSectionMapper = {
    AboutCompany: <AboutCompany />,
    MissionVision: <MissionVision />,
    ContactForm: <ContactForm />,
    SimpleContent: <SimpleContent />,
    AsymmetricInfiniteScrollGridView: <AsymmetricInfiniteScrollGridView />,
    ModernFAQ: <ModernFAQ />,
    FeatureFlow: <FeatureFlow />,
    SequentialFeaturesFlow: <SequentialFeaturesFlow />,
    WhyChooseUs: <WhyChooseUs />,
    SectionsDivider: <SectionsDivider />,
    ModernNavbar: <ModernNavbar />,
    MegaMenuNavbar: <MegaMenuNavbar />,
    HeroSectionWithBottomLabel: <HeroSectionWithBottomLabel />,
    HeroSectionWithScrollTrigger: <HeroSectionWithScrollTrigger />,
    ServiceHero: <ServiceHero />,
    ClientTestimonials: <ClientTestimonials />,
    ComprehensiveFooter: <ComprehensiveFooter />,
}

const getSectionsMapper = (spec) => {
    const section = specToSectionMapper[spec.type]
    const processed = isValidElement(section) ? cloneElement(section, spec) : section
    return processed
}

export * from "./types"
export default getSectionsMapper